import { render, staticRenderFns } from "./EntitlementsPicker.vue?vue&type=template&id=991815f0&scoped=true"
import script from "./EntitlementsPicker.vue?vue&type=script&lang=js"
export * from "./EntitlementsPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991815f0",
  null
  
)

export default component.exports